<script lang="ts" setup>
import YouCanDoThisCard from '../YouCanDoThis/YouCanDoThisCard.vue';

defineProps<{
  imageNumber: InstanceType<typeof YouCanDoThisCard>['$props']['imageNumber'];
}>();
</script>

<template>
  <YouCanDoThisCard :image-number="imageNumber">
    <template #titleText>
      多様な商品を比較検討し、<span
        :class="$style['youCanDoThisTitleText--accent']"
        >あなたに最適な投資プランを</span
      >
    </template>
    <template #detail>
      オカネコのアドバイザーは、ご自身で調べるのが難しいNISAの仕組みやリスクについて、開始前に不明な点や質問があれば、どんなことでも丁寧にお答えし、納得していただけるまでサポートします。それで納得がいかなければ、購入いただかなくても結構です。その場合でも料金は一切いただきませんので、ご安心ください。
    </template>
  </YouCanDoThisCard>
</template>

<style lang="scss" module>
.youCanDoThisTitleText {
  &--accent {
    color: $color-text-and-object-accent-primary;
  }
}
</style>
